"use client";
import { useFlags } from "@stadium/services/launch-darkly/use-flags";
import FeaturedShopSection from "@components/widgets/featured-shop-explore-section";
import { goCatalogUseSwagmagicShopFlag } from "@stadium/services/launch-darkly/constants";
import { LOCKER_SHOP_NUMBER, PROMOTIONAL_STORE_NUMBER } from "@constants/env-variables";

import nikeLogo from "@assets/images/svg/catalog-logos/catalog-logo.svg";
import carharttLogo from "@assets/images/svg/catalog-logos/catalog-logo-1.svg";
import travisMathewLogo from "@assets/images/svg/catalog-logos/catalog-logo-2.svg";
import theNorthfaceLogo from "@assets/images/svg/catalog-logos/catalog-logo-3.svg";
import bellaCanvasLogo from "@assets/images/svg/catalog-logos/catalog-logo-4.svg";
import districtLogo from "@assets/images/svg/catalog-logos/catalog-logo-5.svg";
import portAuthorityLogo from "@assets/images/svg/catalog-logos/catalog-logo-6.svg";
import columbiaLogo from "@assets/images/svg/catalog-logos/catalog-logo-7.svg";
import adidasLogo from "@assets/images/svg/catalog-logos/catalog-logo-8.svg";

import styles from "./main.module.scss";

const LOCKER_CATALOG_CONTENT = {
  buttonText: "BROWSE SWAG CATALOG",
  brandImgs: [
    { src: nikeLogo, alt: "nike" },
    { src: carharttLogo, alt: "carhartt" },
    { src: travisMathewLogo, alt: "travis mathew" },
    { src: theNorthfaceLogo, alt: "the north face" },
    { src: bellaCanvasLogo, alt: "bella plus canvas" },
    { src: districtLogo, alt: "district" },
    { src: portAuthorityLogo, alt: "port authority" },
    { src: columbiaLogo, alt: "columbia" },
    { src: adidasLogo, alt: "adidas" },
  ],
};

const LockerCatalog = (props) => {
  const { [goCatalogUseSwagmagicShopFlag]: goCatalogUseSwagmagicShopFlagEnabled } = useFlags();

  const lockerShopNumber = goCatalogUseSwagmagicShopFlagEnabled
    ? PROMOTIONAL_STORE_NUMBER
    : LOCKER_SHOP_NUMBER;
  return (
    <div className={styles.lockerCatalogContainer}>
      <FeaturedShopSection
        content={LOCKER_CATALOG_CONTENT}
        styles={styles}
        storeNumber={lockerShopNumber}
        linkToCatalogShop={false}
        {...props}
      />
    </div>
  );
};

export default LockerCatalog;
